<template>
  <div class="page-header">
    <div class="header-wrap">
      <div class="logo-container">
        <slot name="logo"></slot>
      </div>
      
      <div class="mobile-menu" @click="showMenu = !showMenu" v-if="getReseller.id == 77">
        <div class="menu-icon">
        </div>
      </div>   
      <topNavVM :class="{ 'nav-active': true, 'height-transition-hidden': !showMenu, 'height-transition': showMenu }" v-if="getReseller.id == 77"/>   
      <div class="telephone-container">
        <span v-if="showTelephone" style="font-size: 100%;"><i class="fa fa-phone fa-rotate-90 mr-2"></i> <strong> <a v-bind:href="'tel:' + telephone">{{telephone}}</a></strong> | </span>
        <span style="font-size: 100%;"><i class="far fa-envelope mr-2"></i> <strong> <router-link to="/contact">Contact Us</router-link> </strong></span>
      </div>      
    </div>
    <div class="top-nav-container" v-if="getReseller.id !== 77">
      <top-nav :navbarType="getReseller.navType" />
    </div>   
  </div>
</template>

<script>
import topNavVM from '@/components/TopNavV2.vue'
import topNav from '@/components/TopNav.vue'
import { mapGetters } from 'vuex';
export default {
  name: 'pageHeader',
  props: {
    showTelephone: Boolean,
    telephone: String
  },
  components: {
    topNavVM,
    topNav
  },
  data: () => ({
    showMenu: false
  }),
  watch: {
    $route(n,o) {
      if(o.path !== n.path) {
        this.showMenu = false;
      }
    }
  },
  computed: {
    ...mapGetters({
      getReseller: 'reseller/getResellerInfo'
    }),
  }
}
</script>